import { useMediaQuery } from '@chakra-ui/react';

import { EquipmentsRepairsMobileView } from './mobile-view';
import EquipmentsRepairsTable from './table';

export const EquipmentsRepairs = () => {

  const [isLarge] = useMediaQuery('(min-width: 768px)', {
    fallback: true
  });
  
  if (isLarge) {
    return <EquipmentsRepairsTable  />;
  }

  return <EquipmentsRepairsMobileView />;
};